var c = Object.defineProperty;
var x = (t, e, r) => e in t ? c(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var u = (t, e, r) => (x(t, typeof e != "symbol" ? e + "" : e, r), r), h = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
};
var _ = (t, e, r) => (h(t, e, "read from private field"), r ? r.call(t) : e.get(t)), a = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, f = (t, e, r, n) => (h(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r);
var o = (t, e, r) => (h(t, e, "access private method"), r);
var i, s, l;
class v {
  constructor({ queue: e, customAttributes: r, eventNamePrefix: n = "", handlePagePath: m }) {
    a(this, s);
    u(this, "_meter", null);
    u(this, "_queue", null);
    u(this, "_customAttributes", null);
    u(this, "_eventNamePrefixArg", null);
    u(this, "_eventNamePrefix", "");
    a(this, i, null);
    if (this._queue = e, this._customAttributes = r, this._eventNamePrefixArg = n, m && typeof m != "function")
      throw new Error("handlePagePath argument must be a function");
    f(this, i, m);
  }
  get queue() {
    return _queue;
  }
  get customAttributes() {
    return _customAttributes;
  }
  setMeter(e) {
    this._meter = e, o(this, s, l).call(this);
  }
  handlePagePath(e) {
    return _(this, i) ? _(this, i).call(this, e) : e;
  }
  addInQueue(e) {
    this._queue && this._queue.push(e);
  }
}
i = new WeakMap(), s = new WeakSet(), l = function() {
  const e = this._meter.eventNamePrefix, r = this._eventNamePrefixArg;
  this._eventNamePrefix = r || e;
};
export {
  v as M
};
